// frontend/src/pages/admin/AdminQueryScope.tsx — Isolierter QueryClientScope fuer /admin.
//
// Zweck:
//   1. Liefert einen separaten adminQueryClient (siehe app/queryClient.ts),
//      der nur fuer Admin-Routen gilt — der globale Client bleibt unberuehrt.
//   2. Raeumt beim UNMOUNT ALLES auf: Cache leeren, Write-Token verwerfen.
//      Damit bleiben KEINE Admin-Daten (Queries, Mutations, Token) uebrig,
//      sobald der User /admin verlaesst — weder im RAM noch auf der Platte
//      (der Write-Token war ohnehin nur in-memory).
//
// Phase 1 = online-only: keine Persistenz, kein Browser-Storage, keine DB.

import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { adminQueryClient } from '../../app/queryClient';
import { clearAdminWriteToken } from './adminWriteToken';

export function AdminQueryScope({ children }: { children: ReactNode }) {
  useEffect(() => {
    return () => {
      // Beim Verlassen von /admin: alle Caches leerraeumen, Token verwerfen.
      // removeQueries + clear ist hier redundant aber explizit — removeQueries
      // entfernt die Eintraege, clear() setzt den Client komplett zurueck.
      adminQueryClient.removeQueries();
      adminQueryClient.clear();
      clearAdminWriteToken();
    };
  }, []);

  return <QueryClientProvider client={adminQueryClient}>{children}</QueryClientProvider>;
}